export const SITE_CONFIG = {
  company: "HDH Pools & Spas",
  phone: "(435) 229-7332",
  email: "Dallin@HDHpools.com",
  location: "Southern Utah",
  domain: "hdhpools.com",
  portalUrl: "#",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_5253d01c-cb13-4e0f-8369-18aea8e030b7/artifacts/ecu1oxjk_IMG_1602.jpg",
  logoAlt: "https://customer-assets.emergentagent.com/job_5253d01c-cb13-4e0f-8369-18aea8e030b7/artifacts/lum6xrpr_IMG_1601.jpg",
  heroPool: "/images/gallery/pool-completed-hero.jpg",
  gallery: [
    {
      src: "/images/gallery/pool-completed-hero.jpg",
      alt: "Completed modern pool with spa - Southern Utah",
      featured: true,
    },
    {
      src: "/images/gallery/pool-slide-spa.jpg",
      alt: "Pool with rock slide and spa - Southern Utah desert",
      featured: true,
    },
    {
      src: "https://customer-assets.emergentagent.com/job_5253d01c-cb13-4e0f-8369-18aea8e030b7/artifacts/72lgz2ir_39B8F9DB-FF7F-415B-A24B-5533B209F598.PNG",
      alt: "Pool with waterfall feature and integrated spa",
      featured: false,
    },
    {
      src: "/images/gallery/pool-tile-detail.jpg",
      alt: "Custom glass tile installation on pool wall",
      featured: false,
    },
    {
      src: "/images/gallery/pool-construction.jpg",
      alt: "Pool construction in progress - Southern Utah",
      featured: false,
    },
    {
      src: "/images/gallery/pool-tile-closeup.jpg",
      alt: "Decorative bubble tile close-up detail",
      featured: false,
    },
  ],
};

export const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};
